<div class="checkout-component" *ngIf="!!pageContent && !screenConfirm">
  <div (click)="cancel();" class="checkout-component-bg"></div>
  <div class="checkout-component-content">
    <svg (click)="cancel();" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
         class="svg-inline--fa fa-times fa-w-10 fa-3x close-checkout">
      <path fill="currentColor"
            d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
            class=""></path>
    </svg>

    <h3 class="checkout-title">{{pageContent.title}}</h3>
    <ul class="list-link">
      <li class="link-item">
        <span class="link-text">{{initCheckOut.subTitle}}</span>
      </li>
      <!--      <li class="link-item">-->
      <!--        <img class="link-icon" [src]="pageContent.iconPayment">-->
      <!--        <span class="link-text">{{pageContent.payment}}</span>-->
      <!--      </li>-->
    </ul>
    <div class="forms-address popup-body">
      <div [ngClass]="{'required':field.showRequired}" *ngFor="let field of pageContent.links.address.fields"
           class="form-item">
        <label class="form-item-label">{{field.name}}</label>
        <input *ngIf="field.type!=='select'" class="form-item-input" [(ngModel)]="field.value"
               [placeholder]="field.placeholder">

        <select (change)="getDistrict(field.value)" *ngIf="field.type==='select' && field.id==='province'"
                class="form-item-input" [(ngModel)]="field.value">
          <option *ngFor="let option of province.provinces" [value]="option.ProvinceId">{{option.ProvinceName}}</option>
        </select>

        <select (change)="getWard(field.value)" *ngIf="field.type==='select' && field.id==='district'"
                class="form-item-input" [(ngModel)]="field.value">
          <option *ngFor="let option of province.districtsView"
                  [value]="option.DistrictId">{{option.DistrictName}}</option>
        </select>

        <select *ngIf="field.type==='select' && field.id==='ward'" class="form-item-input" [(ngModel)]="field.value">
          <option *ngFor="let option of province.wardsView" [value]="option.WardId">{{option.WardName}}</option>
        </select>
        <span class="required">{{initCheckOut.require}}</span>
      </div>
    </div>
    <ul class="list-link">
    </ul>
    <div class="order-summary-container">
      <div class="order-summary">
        <ng-container *ngIf="!!checkOutInfo && !!checkOutInfo.data">
          <div *ngFor="let item of checkOutInfo.data" class="summary-item">
            <div class="text"><span class="summary-text">{{item.name}}</span></div>
            <div class="value">{{item.value}}</div>
          </div>
        </ng-container>

      </div>
    </div>
    <p class="notify-freeship" *ngIf="!(images.length>3)">
      {{initCheckOut.freeShip}}
    </p>
    <div class="bottom-button-container">
      <!--      <div  (click)="images.length>0?nextStep():null" class="bottom-button">-->
      <!--        {{images.length > 0 ? 'Tiếp tục' : 'Vui lòng chọn một ảnh trước'}}-->
      <!--      </div>-->
      <div [ngClass]="{'disable':images.length===0}" (click)="!processing?(images.length>0?checkout():null):null;"
           class="bottom-button">{{images.length > 0 ? (processing ? initCheckOut.process : pageContent.checkoutText) : initCheckOut.plsChoose}}</div>
    </div>
  </div>
</div>


<div class="checkout-component" *ngIf="!!pageContent && screenConfirm">
  <div (click)="cancel();" class="checkout-component-bg"></div>
  <div class="checkout-component-content" *ngIf="!resultOrder">
    <svg (click)="cancel();" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
         class="svg-inline--fa fa-times fa-w-10 fa-3x close-checkout">
      <path fill="currentColor"
            d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
            class=""></path>
    </svg>
    <h3 class="checkout-title">
      <button (click)="screenConfirm=false;" class="back">
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"
             class="svg-inline--fa fa-angle-left fa-w-6 fa-3x">
          <path fill="currentColor"
                d="M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"
                class=""></path>
        </svg>
      </button>
      {{initCheckOut.acceptOrder}}
    </h3>
    <ul class="list-link">
      <li class="link-item">
        <span class="link-text">{{initCheckOut.addressShip}}</span>
      </li>
    </ul>
    <div class="forms-address popup-body">
      <ng-container *ngFor="let field of pageContent.links.address.fields">
        <div class="form-item" *ngIf="!!field.value">
          <label class="form-item-label">{{field.name}}</label>
          <p *ngIf="field.type!=='select'" style="margin: 0" class="form-item-input">{{field.value}}</p>

          <p style="margin: 0" (change)="getDistrict(field.value)"
             *ngIf="field.type==='select' && field.id==='province'"
             class="form-item-input">
            <ng-container *ngFor="let option of province.provinces">
              {{option.ProvinceId === field.value ? option.ProvinceName : ''}}
            </ng-container>
          </p>

          <p (change)="getWard(field.value)" *ngIf="field.type==='select' && field.id==='district'"
             class="form-item-input">
            <ng-container *ngFor="let option of province.districtsView">
              {{option.DistrictId === field.value ? option.DistrictName : ''}}
            </ng-container>
          </p>

          <p *ngIf="field.type==='select' && field.id==='ward'" class="form-item-input">
            <ng-container *ngFor="let option of province.wardsView">
              {{option.WardId === field.value ? option.WardName : ''}}
            </ng-container>
          </p>
        </div>
      </ng-container>

    </div>
    <ul class="list-link">
    </ul>
    <div class="order-summary-container">
      <div class="order-summary">
        <ng-container *ngIf="!!checkOutInfo && !!checkOutInfo.data">
          <div *ngFor="let item of checkOutInfo.data" class="summary-item">
            <div class="text"><span class="summary-text">{{item.name}}</span></div>
            <div class="value">{{item.value}}</div>
          </div>
        </ng-container>

      </div>
    </div>
    <p class="notify-freeship" *ngIf="!(images.length>3)">
      {{initCheckOut.freeShip}}
    </p>
    <div class="bottom-button-container">
      <div (click)="!processing?checkout():null;"
           class="bottom-button">{{processing ? initCheckOut.process : pageContent.checkoutText}}</div>
    </div>
  </div>

  <div class="checkout-component-content" style="display: block;" *ngIf="resultOrder">
    <img class="result-img"
         src="data:image/png;base64,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">
    <h3 class="result-title">{{initCheckOut.orderSuccess}}</h3>
    <p class="result-des">{{initCheckOut.thanks}}</p>
    <div class="succes-box">
      <div class="succes-box-body">
        <div class="list-info-orders">
          <div class="list-info-order-ite">
            <p>{{initCheckOut.orderCode}}</p>
            <span>{{checkOutInfo.orderCode}}</span>
          </div>

          <div class="list-info-order-ite">
            <p>{{initCheckOut.orderDate}}</p>
            <span>{{today|date:'dd/MM/yyyy'}}</span>
          </div>


          <div class="list-info-order-ite">
            <p>{{initCheckOut.totalMoney}}</p>
            <span>{{checkOutInfo.priceCheckout + ' ' + checkOutInfo.priceUnit}}</span>
          </div>


          <div class="list-info-order-ite">
            <p>{{initCheckOut.paymentMethod}}</p>
            <span>{{initCheckOut.paymentMethodInfo}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="succes-box">
      <h3 class="succes-box-title">{{initCheckOut.orderDetail}}</h3>
      <div class="succes-box-body">
        <ng-container *ngFor="let image of images;let i=index;">
          <div class="ss-item-prod">
            <span>{{i + 1}}</span>
            <app-image [image]="image" [imageFrame]="imageFrame" [isMini]="true"></app-image>
            <span>x1</span>
            <span>{{checkOutInfo.price + ' ' + checkOutInfo.priceUnit}}</span>
          </div>
        </ng-container>
        <div *ngFor="let item of checkOutInfo.data" class="ss-item-other">
          <span>{{item.name}}</span>
          <span>{{item.value}}</span>
        </div>
      </div>
    </div>
    <div class="succes-box">
      <h3 class="succes-box-title">{{initCheckOut.addressRec}}</h3>
      <div class=" succes-box-body">
        <ng-container *ngFor="let field of pageContent.links.address.fields">
          <p *ngIf="field.id==='fullname'" class="{{field.id}}">
            {{field.value}}
          </p>
        </ng-container>
        <ng-container *ngFor="let field of pageContent.links.address.fields">
          <p *ngIf="field.id==='phoneNumber'" class="{{field.id}}">
            {{field.value}}
          </p>
        </ng-container>
        <p class="address">
          <ng-container *ngFor="let field of pageContent.links.address.fields">
            <span *ngIf="field.id==='address'">{{field.value}}</span>
          </ng-container>
          <ng-container *ngFor="let field of pageContent.links.address.fields">
            <span *ngIf="field.id==='ward'">
              <ng-container *ngFor="let option of province.wardsView">
              {{option.WardId === field.value ? option.WardName : ''}}
              </ng-container>
            </span>
          </ng-container>
          <ng-container *ngFor="let field of pageContent.links.address.fields">
            <span *ngIf="field.id==='district'">
              <ng-container *ngFor="let option of province.districtsView">
                {{option.DistrictId === field.value ? option.DistrictName : ''}}
            </ng-container>
            </span>
          </ng-container>
          <ng-container *ngFor="let field of pageContent.links.address.fields">
            <span *ngIf="field.id==='province'">
              <ng-container *ngFor="let option of province.provinces">
                {{option.ProvinceId === field.value ? option.ProvinceName : ''}}
              </ng-container>
            </span>
          </ng-container>
        </p>

      </div>
    </div>

    <button (click)="goHome();" class="result-btn">{{initCheckOut.goHome}}</button>
    <div style="height: 48px;width: 100%;"></div>
  </div>
</div>


<app-popup (acceptEvent)="applyAddress();"
           (cancelEvent)="addressPopupShow=false;" *ngIf="addressPopupShow"
           [title]="pageContent.addAddress"
           [acceptText]="pageContent.done">
  <div class="forms-address popup-body">
    <div *ngFor="let field of pageContent.links.address.fields" class="form-item">
      <label class="form-item-label">{{field.name}}</label>
      <input class="form-item-input" [(ngModel)]="field.value" [placeholder]="field.placeholder">
    </div>
  </div>
</app-popup>
